import {GovButton} from "@gov-design-system-ce/react";
import {Variant} from "../Variant";
import {ReactNode} from "react";
import {Box, CircularProgress, Tooltip} from "@mui/material";

const VARIANT_TO_GOV_VARIANT: Record<Variant, "primary" | "secondary" | "error" | "success" | "warning"> = {
    [Variant.PRIMARY]: "primary",
    [Variant.SECONDARY]: "primary",
    [Variant.ERROR]: "error",
};

export interface ButtonProps {
    onClick: () => void;
    variant?: Variant | `${Variant}`;
    disabled?: boolean;
    inProgress?: boolean;
    children: ReactNode;
    size?: "s" | "m" | "l";
    tooltip?: string;
    "data-testid"?: string;
}

export default function Button(props: ButtonProps) {
    const {children, onClick, variant, disabled, inProgress, size = "m", tooltip} = props;
    const testId = props["data-testid"];

    const govType = (variant === Variant.SECONDARY) ? "outlined" : "solid";
    const govVariant = VARIANT_TO_GOV_VARIANT[variant ?? Variant.PRIMARY];

    return (
        <Tooltip title={tooltip} arrow={true}>
            <GovButton type={govType}
                       variant={govVariant}
                       disabled={disabled === true || inProgress === true}
                       size={size}
                       data-testid={testId}
                       onGov-click={onClick}>
                {children}

                <Box sx={{position: "absolute", margin: "auto"}}>
                    {inProgress &&
                        <CircularProgress variant={"indeterminate"}
                                          size={24} />
                    }
                </Box>
            </GovButton>
        </Tooltip>
    );

}
